<template>
  <div class="chat-box">
    <template v-for="(item, index) in chatList">
      <div v-if="item.role === 'assistant'" :key="index" class="chat-item">
        <yxtf-portrait v-if="showPortrait" size="28px" class="portrait" :imgUrl="serviceImg"></yxtf-portrait>
        <div class="chat-core" :class="{'has-portrait': showPortrait, 'chat-core-loading': loading && index === chatList.length - 1 && item.content === ''}">
          <div v-if="item.type === 'chat' && index === chatList.length - 1">
            <div class="chat-status-item" v-for="num in item.receiveState" :key="num">
              <template v-if="num < 4">
                <i class="yxt-icon-loading" v-if="num == item.receiveState"></i>
                <i class="yxt-icon-check" v-else></i>
                {{ item.receiveState === 4 && num === 3 ? RECEIVE_STATUS[item.receiveState] : RECEIVE_STATUS[num] }}
              </template>
            </div>
          </div>
          <div class="chat-content">
            <div class="chat-wrapper">
              <div class="chat-msg" style="min-width: 100px;">
                <div v-if="loading && index === chatList.length - 1 && item.content === ''" class="chat-loading">
                  <span class="loading-dot"></span>
                  <span class="loading-dot"></span>
                  <span class="loading-dot"></span>
                </div>
                <div v-if="['chat', 'logs'].includes(item.type)" v-html="formatContent(item.content)"></div>
                <slot v-else name="customItem" v-bind="{index, data: item}"></slot>
              </div>
              <div v-if="(item.type === 'chat' && index !== chatList.length - 1) || item.appraisement" class="top-option" >
                <slot name="top-option"  v-bind="{index, data: item}"></slot>
              </div>
              <div class="status" v-if="item.appraisement">
                <yxtf-svg width="20px" height="20px" :remote-url="ICON_PATH" :icon-class="item.appraisement === 1 ? 'great' : 'bad'"/>
              </div>
              <slot name="customOption"  v-bind="{index, data: item}"></slot>
            </div>
            <div class="option" v-if="index === chatList.length - 1 && !loading && item.type === 'chat'">
              <slot name="option" v-bind="{index, data: item}"></slot>
            </div>
          </div>
        </div>
      </div>
      <div v-else :key="index + 'user'" class="chat-item right">
        <div class="chat-content" :class="{'has-portrait': showPortrait}">
          <div class="chat-msg mr-3">{{ item.content }}</div>
        </div>
        <yxtf-portrait v-if="showPortrait" size="28px" class="portrait" :imgUrl="userImg"></yxtf-portrait>
      </div>
    </template>
  </div>
</template>

<script>
import markdownit from 'markdown-it';
import { ICON_PATH } from '../config';

const md = markdownit({ breaks: true }).disable(['reference']);

var defaultRender = md.renderer.rules.link_open || function(tokens, idx, options, env, self) {
  return self.renderToken(tokens, idx, options);
};

md.renderer.rules.link_open = function(tokens, idx, options, env, self) {
  var aIndex = tokens[idx].attrIndex('target');
  if (aIndex < 0) {
    tokens[idx].attrPush(['target', '_blank']);
  } else {
    tokens[idx].attrs[aIndex][1] = '_blank';
  }
  return defaultRender(tokens, idx, options, env, self);
};

export default {
  props: {
    loading: {
      default: false
    },
    chatList: {
      default: () => []
    },
    showPortrait: {
      default: true
    },
    userImg: {
      default: localStorage.getItem('imgUrl') || 'https://aibox.bj.bcebos.com//yxt/appIcon/appIcon/011n/美美.jpg'
    },
    serviceImg: {
      default: 'https://aibox.bj.bcebos.com//yxt/appIcon/appIcon/011n/美美.jpg'
    }
  },
  data() {
    return {
      ICON_PATH,
      RECEIVE_STATUS: {
        1: '正在搜索答案',
        2: '正在分析中',
        3: '数据接收中',
        4: '数据接收完成'
      }
    };
  },
  methods: {
    formatContent(content) {
      return md.render(content);
    }
  }
};
</script>
<style lang="scss" scoped>
.chat-item {
  display: flex;
  text-align: left;
  &:not(:last-child) {
    margin-bottom: 20px;
  }
  .portrait {
    margin-right: 12px;
    flex-shrink: 0;
  }
  .chat-core {
    max-width: 100%;
    &.has-portrait{
      max-width: calc(100% - 80px);
    }
    &:not(.chat-core-loading) {
      width: 100%;
    }
  }
  .chat-content {
    max-width: 100%;
    position: relative;
    .chat-wrapper {
      position: relative;
      .top-option {
        position: absolute;
        right: 0;
        top: -16px;
        z-index: 1;
        visibility: hidden;
      }
      &:hover .top-option {
        visibility: visible;
      }
      .status {
        width: 36px;
        height: 36px;
        background: #FFFFFF;
        box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.08);
        border-radius: 26px;
        position: absolute;
        right: 0;
        bottom: -12px;
        color: #436bff;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    ::v-deep .chat-msg {
      padding: 12px 20px;
      min-height: 48px;
      box-sizing: border-box;
      background: #FFFFFF;
      border-radius: 0px 12px 12px 12px;
      color: #262626;
      word-wrap: break-word;
      p {
        margin: 0;
        color: #262626;
      }
      img {
        width: 100%;
      }
      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        font-size: revert;
      }
      ul,
      ol {
        padding-left: 30px;
      }
      ol, ol li {
        list-style: decimal outside;
      }
      ul, ul li {
        list-style: disc outside;
      }
      table {
        margin-bottom: 24px;
        white-space: nowrap;
        thead {
          tr {
            background-color: #f8f8f8;
          }
        }
        td,
        th {
          padding: 6px 13px;
          border: 1px solid #ddd;
          white-space: pre-line;
        }
        tr {
          background-color: #fff;
          border-top: 1px solid #ccc;
          &:nth-child(2n) {
            background-color: #f8f8f8;
          }
        }
      }
    }
    .option {
      margin-top: 8px;
      display: flex;
      justify-content: space-between;
      .option-btn, .option-right {
        background: #FFFFFF;
        border-radius: 16px;
      }
      .option-btn {
        display: inline-flex;
        align-items: center;
        height: 32px;
        line-height: 22px;
        color: #595959;
        padding: 5px 12px;
        box-sizing: border-box;
        cursor: pointer;
        .yxtf-svg-icon {
          margin-right: 5px;
        }
      }
      .option-right {
        display: flex;
        align-items: center;
        padding: 0 16px;
        .option-btn-mini {
          line-height: 0;
          &:not(:last-child) {
            margin-right: 16px;
          }
        }
      }
    }
  }
  &.right {
    justify-content: right;
    .chat-msg {
      border-radius: 12px 0 12px 12px;
      background: #BDD2FF;
    }
    .portrait {
      margin-right: 0;
      margin-left: 12px;
    }
  }
  .chat-status-item {
    font-size: 12px;
    line-height: 1.2;
    color: #999;
    i {
      color: rgba(64, 158, 255, 0.99);
      margin-right: 2px;
    }
    &:last-child {
      margin-bottom: 4px;
    }
  }
}

.chat-loading {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 50px;
  height: 24px;
}

.loading-dot {
  width: 8px;
  height: 8px;
  background-color: #BFBFBF;
  border-radius: 50%;
  animation: scaleAnimation 1s infinite linear;
}

.loading-dot:nth-child(2) {
  animation-delay: 0.333s;
}

.loading-dot:nth-child(3) {
  animation-delay: 0.666s;
}

@keyframes scaleAnimation {
  0% {
    transform: scale(0.6);
    opacity: 0.3;
  }

  50% {
    transform: scale(1.5);
    opacity: 1;
  }

  100% {
    transform: scale(0.6);
    opacity: 0.3;
  }
}
</style>
